import React, { useEffect } from 'react';
import { notification } from 'antd';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { hideNotification } from '../store/slices/uiSlice';

const NotificationSystem: React.FC = () => {
  const dispatch = useAppDispatch();
  const { message, type, open } = useAppSelector((state) => state.ui.notification);

  useEffect(() => {
    if (open && message && type) {
      notification[type]({
        message: type.charAt(0).toUpperCase() + type.slice(1),
        description: message,
        duration: 4.5,
        onClose: () => dispatch(hideNotification()),
      });
    }
  }, [open, message, type, dispatch]);

  return null;
};

export default NotificationSystem;
